import { render } from "./accordion-item.vue?vue&type=template&id=1b0355a6&scoped=true"
import script from "./accordion-item.vue?vue&type=script&lang=js"
export * from "./accordion-item.vue?vue&type=script&lang=js"

import "./accordion-item.vue?vue&type=style&index=0&id=1b0355a6&scoped=true&lang=css"
import "./accordion-item.vue?vue&type=style&index=1&id=1b0355a6&lang=css"

import exportComponent from "/home/runner/work/iam-atkomst-web/iam-atkomst-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0355a6"]])

export default __exports__